import React from 'react';
import { useParams } from 'react-router-dom';
import { titleStyle } from './ReviewTime.styles';
import { useUrlData } from './hooks';
import { Error } from './components';
import { AvatarTitle, SectionContainer, ReviewTimeChart } from '../../components';

const Title = ({ username, days }) => {
  const name = (<strong>{username}</strong>);
  const text = days === 1
    ? '\'s time to first review in the last day.'
    : `'s time to first review in the lasts ${days} days.`;
  return (
    <>
      {name}
      {text}
    </>
  );
};

const Content = () => {
  const { data: input } = useParams();
  const {
    error, user, period, reviews,
  } = useUrlData(input);
  const avatarUrl = `https://avatars2.githubusercontent.com/u/${user?.id}`;

  if (error) return <Error />;

  return (
    <>
      <AvatarTitle
        style={titleStyle}
        avatarUrl={avatarUrl}
        title={<Title username={user.name} days={period} />}
      />
      <ReviewTimeChart reviews={reviews} />
    </>
  );
};

export const ReviewTime = () => (
  <SectionContainer>
    <Content />
  </SectionContainer>
);
